const estateExcelHeaders = [
    "Estate Id",
    "FMC Id",
    "Department Id",
    "Name",
    "Geometry"
]

export default estateExcelHeaders